var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports"},[_c('progress-bar',{attrs:{"progress":_vm.progress}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.currentUploadComponent,{tag:"component",on:{"to":_vm.toState}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }